export type OnboardingStep = {
	id: string;
	title: string;
	description: string;
};

export const ONBOARDING_STEPS: readonly OnboardingStep[] = [
	{
		id: "create-workspace",
		title: "Create a workspace",
		description:
			"Set up your first workspace to organize your team and projects.",
	},
	{
		id: "invite-teammate",
		title: "Invite a teammate",
		description: "Collaborate by inviting a team member to your workspace.",
	},
	{
		id: "explore-resource",
		title: "Explore a sample resource",
		description:
			"Get familiar with the platform by exploring a sample resource.",
	},
] as const;
